function buildSearchTerms(card, parallel, series) {
    const terms = [];

    if (card?.name && card.name.length > 0) {
        terms.push(card.name.join(' '));
    }

    if (series) {
        terms.push(series);
    }

    if (card?.cardNumber) {
        terms.push(`#${card.cardNumber}`);
    }

    if (parallel?.cardParallelName && parallel.cardParallelName !== 'BASE') {
        terms.push(parallel.cardParallelName);
    }

    if (parallel?.cardSupply) {
        terms.push(`/${parallel.cardSupply}`);
    }

    return terms.join(' ');
}

/**
 * Builds an eBay sold/completed listings search URL.
 *
 * @param {Object} card     - Card object with `name` (string[]) and `cardNumber`
 * @param {Object} parallel - Parallel object with `cardParallelName` and `cardSupply`
 * @param {string} series   - Series string (already includes year + manufacturer)
 * @returns {string} eBay search URL filtered to sold/completed listings
 */
export function buildEbaySearchUrl(card, parallel, series) {
    const query = encodeURIComponent(buildSearchTerms(card, parallel, series));
    return `https://www.ebay.com/sch/i.html?_nkw=${query}&LH_Sold=1&LH_Complete=1`;
}

/**
 * Builds an eBay Seller Hub Product Research URL for a 730-day sold window.
 *
 * @param {Object} card     - Card object with `name` (string[]) and `cardNumber`
 * @param {Object} parallel - Parallel object with `cardParallelName` and `cardSupply`
 * @param {string} series   - Series string (already includes year + manufacturer)
 * @returns {string} eBay Product Research URL
 */
export function buildEbayResearchUrl(card, parallel, series) {
    const DAY_RANGE = 730;
    const endDate   = Date.now();
    const startDate = endDate - DAY_RANGE * 24 * 60 * 60 * 1000;
    const tz        = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const params = new URLSearchParams({
        marketplace: 'EBAY-US',
        keywords:    buildSearchTerms(card, parallel, series),
        dayRange:    DAY_RANGE,
        endDate,
        startDate,
        categoryId:  0,
        offset:      0,
        limit:       50,
        tabName:     'SOLD',
        tz,
    });

    return `https://www.ebay.com/sh/research?${params.toString()}`;
}
